import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=5cb99d37&scoped=true&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NotFound.vue?vue&type=style&index=1&id=5cb99d37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb99d37",
  null
  
)

export default component.exports